<fin-section-review
  containerSpacing="ps-medium"
  [title]="'purchase.review.priceBreakdown' | finLocalization"
  [noButton]="true"
  [roundedBottom]="false"
  [showPaddingBottom]="false"
  class="ms-large-t"
>
  <ng-container ngProjectAs="content">
    <fin-price-breakdown-renewed
      class="flex--basis-full"
      [prices$]="prices$"
      [breakdownTotalValue$]="breakdownTotalPrice$"
      [passengers$]="order$ | finMap: 'passengers'"
      [helperText]="helperText()"
      [showInExpand]="false"
      [showBaseFare]="false"
      [showPassengerCount]="false"
      [showFareDifference]="true"
      [breakdownTotalKey$]="breakdownTotalKey$"
    />
  </ng-container>
</fin-section-review>
<div
  data-testid="breakdown-total-price"
  class="flex nordic-blue-900-bg surface-contrast border-bottom border-left border-right rounded-bottom-large ps-medium"
>
  <h2 class="font-heading-4 flex white-text text-icon-reversed font-title-medium">
    {{ breakdownTotalKey$ | async | finLocalization }}
  </h2>
  <span
    class="flex-1 flex--basis0 flex font-heading-4 bold-type flex--wrap flex--end align-right white-text text-icon-reversed font-title-medium"
    >{{ breakdownTotalPrice$ | async | finPrice: { absoluteValue: true } }}</span
  >
</div>
